import React, { useEffect, useState } from "react";
import UploadAdImage from "./UploadAdImage";
import { API_BASE_URL } from "../../config";
import AdSelector from "./AdSelector"; // Adjust path as needed

export default function CustomerAds() {
    const [ads, setAds] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [showUpload, setShowUpload] = useState(false);
    const [selectedAdId, setSelectedAdId] = useState(null);

    useEffect(() => {
        fetchAds();
        // eslint-disable-next-line
    }, []);

    const fetchAds = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${API_BASE_URL}/api/customer/ads`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            const data = await res.json();
            setAds(data.images || []);
        } catch {
            setMessage("Failed to load ads.");
        }
        setLoading(false);
    };

    const handleDeleteAd = async (adId) => {
        if (!window.confirm("Are you sure you want to delete this ad?")) return;
        try {
            const res = await fetch(`${API_BASE_URL}/api/customer/ads/${adId}`, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            if (res.ok) {
                setAds((prev) => prev.filter((ad) => ad.id !== adId));
                setMessage("Ad deleted.");
            } else {
                setMessage("Failed to delete ad.");
            }
        } catch {
            setMessage("Failed to delete ad.");
        }
    };

    return (
        <div style={{ maxWidth: 900, margin: "2rem auto", background: "#fff", borderRadius: 8, boxShadow: "0 2px 8px #ea476e22", padding: 24 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
                <h2 style={{ color: "#ea476e" }}>My Ads</h2>
                <button
                    onClick={() => setShowUpload((v) => !v)}
                    style={{
                        background: "#ea476e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        padding: "0.5rem 1.5rem",
                        fontWeight: 600,
                        fontSize: "1rem",
                        cursor: "pointer",
                    }}
                >
                    {showUpload ? "Close Upload" : "Upload New Ad"}
                </button>
            </div>
            {showUpload && (
                <UploadAdImage refreshAds={fetchAds} />
            )}
            {loading ? (
                <div>Loading...</div>
            ) : ads.length === 0 ? (
                <div style={{ color: "#888" }}>You have not uploaded any ads yet.</div>
            ) : (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 24 }}>
                    {ads.map((ad) => (
                        <div
                            key={ad.id}
                            style={{
                                background: "#fafafa",
                                borderRadius: 8,
                                boxShadow: "0 2px 8px #ea476e11",
                                padding: 16,
                                width: 220,
                                position: "relative",
                            }}
                        >
                            <img
                                src={`${API_BASE_URL}${ad.url}`}
                                alt={ad.image_metadata?.advertisement_name || "Ad"}
                                style={{ width: "100%", borderRadius: 4, marginBottom: 8 }}
                            />
                            <div>
                                <strong>{ad.image_metadata?.advertisement_name || "Untitled"}</strong>
                            </div>
                            <div>{ad.image_metadata?.company_name}</div>
                            <div style={{ fontSize: 12, color: "#888" }}>{ad.image_metadata?.company_url}</div>
                            <div style={{ fontSize: 13, marginTop: 4 }}>{ad.image_metadata?.description}</div>
                            <button
                                style={{
                                    marginTop: 10,
                                    background: "#f44336",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",
                                    padding: "0.3rem 1rem",
                                    cursor: "pointer",
                                    width: "100%",
                                }}
                                onClick={() => handleDeleteAd(ad.id)}
                            >
                                Delete
                            </button>
                        </div>
                    ))}
                </div>
            )}
            <AdSelector
                ads={ads}
                selectedAdId={selectedAdId}
                onSelect={setSelectedAdId}
            />
            {message && (
                <div style={{ marginTop: 18, color: "#ea476e", textAlign: "center", fontWeight: 600 }}>
                    {message}
                </div>
            )}
        </div>
    );
}